import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import VueAxios from 'vue-axios'
import { plainAxiosInstance, formAxiosInstance, plainAxiosInstanceAuth } from './api/apiMotoBoutique'
import $ from 'jquery'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(VueAxios, {
    plain: plainAxiosInstance,
    plainAuth: plainAxiosInstanceAuth,
    form: formAxiosInstance,
})
appInstance.config.globalProperties.$jQuery = $
appInstance.use(VueSweetalert2);
appInstance.mount("#app");
